import React from 'react';
import logoImage from '../assets/resize.webp'; // импорт изображения

const Header = () => {
  return (
    <header>
      <div className="container header-top">
        <div className="logo">
          <div className="logo-icon">
            <div className="logo-icon-img">
               <img src={logoImage} alt="Логотип КПРФ" /> {/* используем импорт */}
            </div>
          </div>
          <div className="logo-text">
            <h1>Нефтеюганское городское отделение</h1>
            <p>Ханты-Мансийского автономного округа – Югры</p>
          </div>
        </div>
        <div className="header-contacts">
          <p><i className="fas fa-phone"></i> +7 922 433 47 00</p>
          <p><i className="fas fa-envelope"></i> i7777775@mail.ru</p>
        </div>
      </div>
      <div className="party-name">
        КОММУНИСТИЧЕСКАЯ ПАРТИЯ РОССИЙСКОЙ ФЕДЕРАЦИИ
      </div>
    </header>
  );
};

export default Header;